import React from 'react'

// import the api
import { useGetCoursesSectionQuery } from '../api/courses';

/**
 * @param {integer} [courseRecordId] - Displaid Course's template record id
 */
function CourseNotes({courseRecordId}) {

    // get the future courses with the new RTK query
    // Using a query hook automatically fetches data and returns query values
    const { currentData, isFetching } = useGetCoursesSectionQuery({templateId: courseRecordId, sections: 'notes'});

    const getNotes = () => {
        if(currentData && !isFetching && currentData.notes?.length > 0){
            return(
                <div class="pattern-block">
                    <div class="container">
                        <div className="messages warning">
                            <h4>Notes</h4>
                            {currentData.notes.map((note)=>{
                                return(
                                    <p>{note.message}.</p>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )
        }
    }

    // Component level JSX return statement ******************************************************
    return (
        <>
            {getNotes()}
        </>
    )
}
export default CourseNotes;